import { isEmpty, type Optional } from '@festina-life/core'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

export const useTranslatePolicy = () => {
  const translateEnum = useTranslateEnum()

  return useCallback(
    (policyKey: Optional<string>) => {
      if (isEmpty(policyKey)) {
        return '-'
      }

      const [templateIdentifier, policyNumber] = policyKey.split('#')

      const translatedPolicy = translateEnum(
        'enum.PolicyType',
        templateIdentifier,
      )

      return isEmpty(policyNumber)
        ? translatedPolicy
        : `${translatedPolicy} #${policyNumber}`
    },
    [translateEnum],
  )
}
